

export interface IVotingQuestions{


    question?:string  ,
    expiry_Date?: Date ,
    voting_Que_ID?:number ,
    voting_Answer?:string,
    submitted_Answer?:number | null | string,
    submitted_Date?: string
}



export const EmptyVotingQuestions:IVotingQuestions ={
    question: '',
    expiry_Date: undefined,
    voting_Que_ID: 0,
    submitted_Answer:null
}